import { select } from 'd3-selection';
import { useEffect } from 'react';

import type { Selection } from 'd3-selection';

interface CommonDataPoint {
  x: string;
}

interface Options {
  maxTextWidth: number;
  padding?: number;
}

export const useSvgTextTruncate = <
  Element extends SVGTextContentElement,
  DataPoint extends CommonDataPoint,
>(
  selection: Selection<Element, DataPoint, null, unknown>,
  { maxTextWidth, padding = 8 }: Options,
) => {
  useEffect(() => {
    selection.each(function truncate({ x }) {
      const self = select(this).text(x);
      let text = self.text();
      let textLength = self.node()?.getComputedTextLength() ?? 0;

      while (textLength > maxTextWidth - padding && text.length > 0) {
        text = text.slice(0, -1);
        self.text(`${text}...`);
        textLength = self.node()?.getComputedTextLength() ?? 0;
      }
    });
  }, [maxTextWidth, padding, selection]);
};
